import { BASE_QUERY, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from './shared/configs';

const values = [
  'Journal Reports',
  'US: Journal Reports',
  'World: Journal Reports',
  'Journal Reports: College Rankings',
  'Journal Reports: Energy',
  'Journal Reports: Health Care',
  'Journal Reports: Investing Monthly',
  'Journal Reports: Leadership',
  'Journal Reports: Retirement',
  'Journal Reports: Small Business',
  'Journal Reports: Technology',
  'Journal Reports: Personal Investing',
  'Journal Reports: Wealth Management'
];
const MAIN = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: values } }, { terms: { key: 'Keyword', value: values } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

export { MAIN, SECTION_TOP };
